export default __webpack_public_path__ + "static/media/iconeCertificadoresMaior.51124d1f.png";